(() => {
  const selector = '[data-review-demo="true"]';

  const paintDemo = (element) => {
    const productId = Number(element.dataset.productId);
    if (!Number.isSafeInteger(productId) || productId <= 0) return;
    const rating = Math.round((4 + (productId % 100) / 100) * 2) / 2;
    const count = (productId % 251) + 50;
    const formattedRating = rating.toFixed(1).replace('.', ',');
    const text = element.querySelector('[data-review-demo-text]');
    const ratingText = element.querySelector('[data-review-demo-rating]');
    if (text && element.dataset.reviewDemoTemplate) {
      text.textContent = element.dataset.reviewDemoTemplate
        .replaceAll('__rating__', formattedRating)
        .replaceAll('__count__', String(count));
    }
    if (ratingText) ratingText.textContent = `${formattedRating} / 5`;
    element.querySelectorAll('.alma-review-stars__tile').forEach((star, index) => {
      const fill = Math.max(0, Math.min(100, (rating - index) * 100));
      star.style.setProperty('--star-fill', `${fill}%`);
    });
  };

  const updateDemo = (root) => {
    if (root.matches?.(selector)) paintDemo(root);
    root.querySelectorAll?.(selector).forEach(paintDemo);
  };

  const startDemo = () => {
    updateDemo(document);
    const observer = new MutationObserver((records) => {
      records.forEach((record) => {
        if (record.type === 'attributes') {
          if (record.target.matches(selector)) paintDemo(record.target);
          return;
        }
        record.addedNodes.forEach((node) => {
          if (node.nodeType === 1) updateDemo(node);
        });
      });
    });
    observer.observe(document.documentElement, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['data-product-id']
    });
    document.addEventListener('shopify:section:load', (event) => updateDemo(event.target));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startDemo, { once: true });
  } else {
    startDemo();
  }
})();
